export default __webpack_public_path__ + "static/media/cvod-R16.14c5891d.svg";